import { render, staticRenderFns } from "./ModalCreateItemGroup.vue?vue&type=template&id=5f6bc018&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ModalCreateItemGroup.vue?vue&type=script&lang=js&"
export * from "./ModalCreateItemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6bc018",
  null
  
)

export default component.exports